import React from "react";
import { TransformationContext } from "./TransformationContext";
import { useRenderTarget, RenderTarget } from "./renderTarget";
import { createPDFStyleSheet } from "./cssHelpers";
import PdfListUtils from "../PdfLists/general/PdfListUtils";
import PdfImagePlaceholder from "./PdfImagePlaceholder";
import { stringToShortKey } from "../../models/utils";
import { getPdfRenderer } from "../../getPdfRenderer";

export type RImgProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  style?: React.CSSProperties;
  src: string;
  alt?: string;
  autoWidth?: boolean;
  noOptimize?: boolean;
};

export const RImg = React.forwardRef<HTMLImageElement, RImgProps>((props, ref) => {
  const target = useRenderTarget();
  const parentTransformation = React.useContext(TransformationContext);
  const { style, children, autoWidth, ...rest } = props as any;

  if (target === RenderTarget.web) {
    const { style, children, ...rest } = props as any;
    return <img ref={ref} {...rest} style={style} />;
  }

  PdfListUtils.convertStyleUnitsForPDF(style, "RImg"); // no itx
  PdfListUtils.applyTransformation(style, parentTransformation);

  // PDF-StyleSheet erstellen
  let pdfStyle = createPDFStyleSheet(style);


  const pdf = getPdfRenderer();
  if (!pdf) return null;

  const { Image } = pdf;

  if (props.noOptimize) {
    return <Image src={props.src} style={pdfStyle} />;
  }

  const imgStyle = { ...pdfStyle };
  if (autoWidth) {
    imgStyle.width = 0;
  }

  const id = props.id || stringToShortKey(props.src);

  return <PdfImagePlaceholder id={id} style={imgStyle} url={props.src} />;

  // return (
  //     <View style={{ ...pdfStyle, display: "flex", alignItems: "center", justifyContent: "center" }}>
  //         <PdfImagePlaceholder id={id} style={imgStyle} url={props.src} />
  //     </View>
  // );
});
